export default "__VITE_ASSET__B2GrVKiW__"